import {
  Fab,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import LandingPage from "../../pages/LandingPage/LandingPage";
import "./MainContent.css";
import { setProcurementDivisionType } from "../../redux/actions/userTypeSlice";
import TicketModal from "./TicketModal";
import { clearSelectedItem } from "../../redux/actions/SupportTicket/selectionSlice";
import LtTicketModal from "./LtTicketModal";
import { getProcurementDivisionType } from "../../utils/procurementDivision";

const MainContent = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const CDRole = localStorage.getItem("CDRole");
  const tabDetails = useSelector((state) => state?.dashboardDetails?.tabDetails);
  const cardTitle = useSelector((state) => state?.userCardType?.cardTitle);
  
  // Determine role type
  const isPackagingRole = CDRole === "Price Memo Owner (Packaging)" || CDRole === "Price Memo Viewer (Packaging)";
  const isCepgRole = CDRole === "Price Memo Owner (CEPG)" || CDRole === "Price Memo Viewer (CEPG)"

  // Initialize state with correct default based on role
  const [type, setType] = useState(() => {
    const stored = localStorage.getItem("procurementDivisionType");
    if (stored) return stored;
    return getProcurementDivisionType(CDRole);
  });
  
  const [showModal, setShowModal] = useState(false);
  const [showLTSupportModal, setShowLTSupportModal] = useState(false);

  const userEmail = localStorage.getItem("data");
  const selectedItem = useSelector((state) => state?.selectionSlice?.selectedItem);

  const handleChange = (event) => {
    const newValue = event.target.value;
    setType(newValue);
    dispatch(setProcurementDivisionType(newValue));
    localStorage.setItem("procurementDivisionType", newValue);
  };

  const handleAddSupportClick = () => {
    setShowModal(true);
  }
  const handleAddLTSupportClick = () => {
    setShowLTSupportModal(true);
  }

  // Update procurement division type when role changes
  useEffect(() => {
    const nextDivisionType = getProcurementDivisionType(CDRole);
    if (nextDivisionType) {
      setType(nextDivisionType);
      dispatch(setProcurementDivisionType(nextDivisionType));
      localStorage.setItem("procurementDivisionType", nextDivisionType);
    }
  }, [CDRole, dispatch])

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, null, window.location.href);
    };
    dispatch(setProcurementDivisionType(type));
  }, [dispatch, type])

  useEffect(() => {
    dispatch(clearSelectedItem());
  }, [dispatch, location.pathname])

  const shouldRenderDropdown =
    cardTitle === "Contract Data Update" &&
    location?.pathname !== "/contract-maintenance" &&
    location?.pathname !== "/cm-reports" &&
    location?.pathname !== "/contract-maintenance/new-contract" &&
    location?.pathname !== "/contract-maintenance/update-contract" &&
    location?.pathname !== "/contract-maintenance/review-auto-target-value"

  return (
    <div
      className={
        tabDetails.title === "Landing" ? "landing-content" : "main-content"
      }
    >
      {tabDetails.title === "Landing" ? (
        <LandingPage />
      ) : (
        <>
          <div className="sidebar">
            <List sx={{ marginTop: "15px" }} className="sideBarOptionsList">
              {shouldRenderDropdown && (
                <FormControl
                  sx={{ m: 1, width: "-webkit-fill-available" }}
                  size="small"
                >
                  <InputLabel id="demo-select-small-label">
                    Price Memo
                  </InputLabel>
                  {isPackagingRole ? (
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={type}
                      label="Procurement Division"
                      onChange={handleChange}
                    >
                      <MenuItem value="Packaging">Packaging</MenuItem>
                    </Select>
                  ) : isCepgRole ? (
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={type}
                      label="Procurement Division"
                      onChange={handleChange}
                    >
                      <MenuItem value="CEPG">CEPG</MenuItem>
                    </Select>
                  ) : (
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={type}
                      label="Procurement Division"
                      onChange={handleChange}
                    >
                      <MenuItem value="SIS">SIS</MenuItem>
                      <MenuItem value="Agri">Agriculture</MenuItem>
                      <MenuItem value="Packaging">Packaging</MenuItem>
                      <MenuItem value="CEPG">CEPG</MenuItem>
                    </Select>
                  )}
                </FormControl>
              )}
              {cardTitle === "Contract Data Update"
                ? props.mdmMenuItems?.map((item) => (
                  <ListItem
                    key={item.title}
                    disablePadding
                    onClick={() =>
                      props.handleMenuItemClick(item.path, item.label, item)
                    }
                  >
                    <ListItemButton
                      selected={item.path === location.pathname || item.path}
                      style={{
                        backgroundColor:
                          item.path === location.pathname ||
                            (location.pathname === "/material_details" &&
                              item.path === "/analytics-results") ||
                            location.pathname.includes(item.path)
                            ? "#717171"
                            : "#aaaaaa",
                      }}
                      className="listButtonSection"
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: 3,
                          justifyContent: "center",
                        }}
                        style={{
                          display: "flex",
                          margin: "auto",
                          color: "#fff",
                        }}
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.label}
                        sx={{
                          opacity: 1,
                          ".MuiTypography-root": {
                            fontSize: "12px !important",
                          },
                        }}
                        style={{ color: "#fff" }}
                      />
                    </ListItemButton>
                  </ListItem>
                ))
                : cardTitle === "Lead Time Analytics"
                  ? props.menuItems?.map((item) => (
                    <ListItem
                      key={item.title}
                      disablePadding
                      onClick={() =>
                        props.handleMenuItemClick(item.path, item.label, item)
                      }
                    >
                      <ListItemButton
                        selected={
                          item.path === location.pathname ||
                          item.pathname ===
                          localStorage.getItem("LTPathName") ||
                          item.path
                        }
                        style={{
                          backgroundColor:
                            item.path === location.pathname ||
                              (location.pathname === "/material_details" &&
                                item.path === "/analytics-results") ||
                              (location.pathname ===
                                "/admin-analytics-results-details" &&
                                item.path === "/admin-analytics-results") ||
                              (location.pathname ===
                                "/detailed-results-approval" &&
                                item.path === "/approval-management") ||
                              (location.pathname ===
                                "/DPS-Planner-analytics-Details" &&
                                item.path === "/DPS-Planner-analytics") ||
                              (location.pathname ===
                                "/viewer-analytics-results-details" &&
                                item.path === "/viewer-analytics-results") ||
                              (location.pathname ===
                                "/gmp-analytics-results-details" &&
                                item.path === "/gmp-analytics-results") ||
                              (location.pathname === "/DPS-analytics-Details" &&
                                item.path === "/DPS-analytics")
                              ? "#717171"
                              : "#aaaaaa",
                        }}
                        className="listButtonSection"
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: 3,
                            justifyContent: "center",
                          }}
                          style={{
                            display: "flex",
                            margin: "auto",
                            color: "#fff",
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={item.label}
                          sx={{
                            opacity: 1,
                            ".MuiTypography-root": {
                              fontSize: "12px !important",
                            },
                          }}
                          style={{ color: "#fff" }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))
                  : props.aribaMenuItems?.map((item) => (
                    <ListItem
                      key={item.title}
                      disablePadding
                      onClick={() =>
                        props.handleMenuItemClick(item.path, item.label, item)
                      }
                    >
                      <ListItemButton
                        selected={item.path === location.pathname || item.path}
                        style={{
                          backgroundColor:
                            item.path === location.pathname ||
                              (location.pathname === "/material_details" &&
                                item.path === "/analytics-results") ||
                              location.pathname.includes(item.path)
                              ? "#717171"
                              : "#aaaaaa",
                        }}
                        className="listButtonSection"
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 0,
                            mr: 3,
                            justifyContent: "center",
                          }}
                          style={{
                            display: "flex",
                            margin: "auto",
                            color: "#fff",
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={item.label}
                          sx={{
                            opacity: 1,
                            ".MuiTypography-root": {
                              fontSize: "12px !important",
                            },
                          }}
                          style={{ color: "#fff" }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
            </List>
          </div>
          <div className="content">
            <div>
              {(cardTitle === "Contract Data Update" && location.pathname !== "/cd-dashboard" && location.pathname !== "/ticket-summary" && location.pathname !== "/audit-logs") && (
                <Fab
                  variant="extended"
                  disabled={location.pathname === "/ticket-summary" || location.pathname === "/cd-dashboard"}
                  style={{
                    position: "fixed",
                    bottom: "22px",
                    left: "2px",
                    zIndex: 1000,
                    background: `${(location.pathname === "/ticket-summary" || location.pathname === "/cd-dashboard") ? '#0000001f' : "#64cac6"}`,
                    color: "#fff",
                    padding: '10px 20px',
                  }}
                  onClick={handleAddSupportClick}
                >
                  <AddIcon sx={{ mr: 1 }} />
                  Support
                </Fab>
              )}
              {(cardTitle === "Lead Time Analytics" && location?.pathname !== "/lt-ticketsummary") && (
                <Fab
                  variant="extended"
                  disabled={location.pathname === "/lt-ticketsummary"}
                  style={{
                    position: "fixed",
                    bottom: "22px",
                    left: "2px",
                    zIndex: 1000,
                    background: `${(location.pathname === "/lt-ticketsummary") ? '#0000001f' : "#64cac6"}`,
                    color: "#fff",
                    padding: '10px 20px',
                  }}
                  onClick={handleAddLTSupportClick}
                >
                  <AddIcon sx={{ mr: 1 }} />
                  Support
                </Fab>
              )}
              <Outlet />
            </div>
          </div>
          <TicketModal
            showModal={showModal}
            title="Support Ticket"
            handleClose={() => setShowModal(false)}
            userEmail={userEmail}
            selectedItem={selectedItem}
          />
          <LtTicketModal
            showModal={showLTSupportModal}
            title="Support Ticket"
            handleClose={() => setShowLTSupportModal(false)}
            userEmail={userEmail}
            selectedItem={selectedItem}
          />
        </>
      )}
    </div>
  );
};

export default MainContent;
